import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/auth-context";
import LoadingScreen from "./loading-screen";

export default function RoleRoute({
  children,
  allowedRoles,
}: {
  children: React.ReactNode;
  allowedRoles: string[];
}) {
  const auth = useContext(AuthContext);

  if (auth?.loading) {
    return <LoadingScreen />;
  }

  if (!auth?.user) {
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.includes(auth.user.role)) {
    return <Navigate to="/feed" replace />;
  }

  return <>{children}</>;
}
